import React from 'react';
import Layout from './src/components/layout';
// Minimal local types to avoid relying on Gatsby's exported namespaces
type LocationLike = Location & { key?: string };
type RouteUpdateArgsLike = { location: LocationLike; prevLocation: LocationLike | null };
type WrapPageElementArgsLike = { element: React.ReactElement; props: any };


// Flag to detect "popstate" (browser back/forward button)
let isPop = false;
// Storage for scroll positions, keyed by location.key or pathname
const scrollPositions: Record<string, number> = {};

// Listen for back/forward navigation events in the browser
if (typeof window !== 'undefined') {
  window.addEventListener('popstate', () => {
    isPop = true;
  });
}

export const onClientEntry = () => {
  // Disable automatic browser scroll restoration
  if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
};

// Save the current scroll position before navigating away
export const onPreRouteUpdate = ({
  prevLocation,
}: { prevLocation?: { key?: string; pathname: string } }) => {
  if (prevLocation) {
    const key = prevLocation.key || prevLocation.pathname;
    scrollPositions[key] = window.scrollY;
  }
};

// On route change, decide whether to restore previous scroll or jump to top
export const onRouteUpdate = ({
  location,
}: { location: { key?: string; pathname: string; hash: string } }) => {
  const key = location.key || location.pathname;
  
  // Check if this is an anchor link navigation
  const hasHash = location.hash && location.hash.length > 0;
  
  if (isPop && typeof scrollPositions[key] === 'number') {
    // Back/forward navigation: restore the previous scroll
    setTimeout(() => window.scrollTo(0, scrollPositions[key]), 50);
  } else if (hasHash) {
    // Anchor link navigation: let the browser handle the scroll naturally
    // Don't interfere with the anchor scroll behavior
    return;
  } else {
    // Forward navigation without anchor: scroll to top
    setTimeout(() => window.scrollTo(0, 0), 50);
  }
  isPop = false;
};

// Wrap each page in Layout
export const wrapPageElement = ({
  element,
  props,
}: { element: React.ReactNode; props: Record<string, unknown> }) => {
  return <Layout {...props}>{element}</Layout>;
};